export const LightEffects = () => {
  return (
    <>
      {/* Vệt sáng trái */}
      <div className="absolute left-0 top-1/3 w-1/2 h-1/3 bg-[radial-gradient(circle,_white_0%,_transparent_70%)] opacity-40 blur-3xl" />

      {/* Vệt sáng phải */}
      <div className="absolute right-0 top-1/3 w-1/2 h-1/3 bg-[radial-gradient(circle,_white_0%,_transparent_70%)] opacity-40 blur-3xl" />

      {/* Vùng sáng tròn trên giữa */}
      <div className="absolute top-10 left-1/2 -translate-x-1/2 w-2/3 h-1/3 bg-[radial-gradient(circle,_white_0%,_transparent_70%)] opacity-50 blur-2xl" />
    </>
  );
}